module.exports = __webpack_public_path__ + "static/media/1POLICY40.8e4f3d74.jpg";